var ltr6_module_tabs = (function (ltr6_module_tabs) {

    ltr6_module_tabs.init = function(){
      
      // got a bit of a mess now had to add accordion to it all.
      // tabs were doing fading, and animating the container size after switching which messes accordion
      // so now there are 2 functions to open tab or accordion but setting it all so it works when
      // switching between the 2
      // works fine, but could do with tidying up please.

      ltr6_module_tabs.fadeSpeed = 0.1;
      ltr6_module_tabs.slideSpeed = 0.5;


      // tab headings and previous/ next buttons
      $('#ltr6-wrapper').on('click', '.ltr6-tabs a[data-tab-link]', function(event) {
        event.preventDefault();
        var tabClass = $(this).attr('data-tab-link');
        var tabs = $(this).closest('.ltr6-tabs');

        // tab or accordion.
        if (window.matchMedia('(max-width: 767px)').matches) {
          ltr6_module_tabs.setActiveAccordion(tabs,tabClass);
        } else {
          ltr6_module_tabs.setActiveTab(tabs,tabClass);
        }
      });

      // accordion only buttons
      $('#ltr6-wrapper').on('click', '.ltr6-tabs .ltr6-accordion-toggle button', function(event) {
        event.preventDefault();
        event.stopPropagation();
        var tabClass = $(this).attr('data-tab-link');
        var tabs = $(this).closest('.ltr6-tabs');
        ltr6_module_tabs.setActiveAccordion(tabs,tabClass);
      });
      



      // ===================================================
      // ACCORDION
      // ===================================================

      ltr6_module_tabs.setActiveAccordion = function(tabGroup,tabClass){

        // var tabGroup = $('.ltr6-tabs');
        var trackingName = tabGroup.attr('data-tracking-name');
        var tabContainer = tabGroup.find('.ltr6-tabs-container');
        var allLinks = tabGroup.find('ul li');
        var newLink = tabGroup.find('ul li.'+tabClass)
        var allTabs = tabGroup.find('.ltr6-tab');
        var oldTab = tabGroup.find('.ltr6-tab.active');
        var newTab = tabGroup.find('.ltr6-tab.'+tabClass);
        var allAccordionlinks = tabGroup.find('.ltr6-accordion-toggle');
        var newAccordionLink = tabGroup.find('.ltr6-accordion-toggle.'+tabClass);

        if(newTab.hasClass('active')) {
          TweenLite.to(oldTab,ltr6_module_tabs.slideSpeed,{height:0,onComplete:function(){
            oldTab.removeClass('active');
            oldTab.removeClass('active');
            oldTab.css('height','auto');
            allAccordionlinks.removeClass('active');
            allAccordionlinks.find('button').blur();
          }});

        } else {
          allAccordionlinks.removeClass('active');
          newAccordionLink.addClass('active');

          allLinks.removeClass('active');
          newLink.addClass('active');

          newTab.addClass('active');
          newTab.css('height','auto');
          newTab.css('opacity',1);

          var newTabHeight = newTab.prop('scrollHeight');
          // newTab.removeClass('active');
          // console.log('newTab',newTab);
          // console.log('oldTab',oldTab);


          TweenLite.to(oldTab,ltr6_module_tabs.slideSpeed,{height:0,onComplete:function(){
            oldTab.removeClass('active');
            oldTab.css('height','auto');
          }});
          TweenLite.fromTo(newTab,ltr6_module_tabs.slideSpeed,{height:0},{height:newTabHeight,onComplete:function(){
            // oldTab.removeClass('active');
            newTab.css('height','auto');
            allAccordionlinks.find('button').blur();


            // // scroll to top of tab content if off top of screen
            // // var tabTop = $('#ltr6-wrapper .ltr6-tabs .ltr6-tab.'+tabClass)[0].offsetTop;
            // var tabTop = tabGroup.find('.ltr6-tab.'+tabClass)[0].offsetTop;
            // var headerHeight = $('nav.c-nav').outerHeight();
            // // console.log('tabTop',tabTop);
            // // console.log('headerHeight',headerHeight);
            // var currentScrollPos = document.documentElement.scrollTop || document.body.scrollTop;
            // var scrollToPos = tabTop - headerHeight - 54;
            // // if(currentScrollPos > scrollToPos){
            //   TweenLite.to(window, 0.3, {scrollTo:{y:scrollToPos},ease:Power1.easeInOut});
            // // }

          }});


          var title = newAccordionLink.text();

          ltr6_module_analytics.tracking_adobe(title,'Button','Click','Tabs - ' + trackingName);
          ltr6_module_analytics.tracking_decibel(title,'Button','Click','Tabs - ' + trackingName);



        }


      };


      // ===================================================
      // TAB
      // ===================================================

      ltr6_module_tabs.setActiveTab = function(tabGroup,tabClass){

        // var tabClass = $(this).attr('data-tab-link');
        // var tabGroup = $('.ltr6-tabs');
        var trackingName = tabGroup.attr('data-tracking-name');
        var tabContainer = tabGroup.find('.ltr6-tabs-container');
        var allLinks = tabGroup.find('ul li');
        var newLink = tabGroup.find('ul li.'+tabClass)
        var allTabs = tabGroup.find('.ltr6-tab');
        var oldTab = tabGroup.find('.ltr6-tab.active');
        var newTab = tabGroup.find('.ltr6-tab.'+tabClass);
        var allAccordionlinks = tabGroup.find('.ltr6-accordion-toggle');
        var newAccordionLink = tabGroup.find('.ltr6-accordion-toggle.'+tabClass);
        
        if(newTab.hasClass('active')) return false;

        allAccordionlinks.removeClass('active');
        newAccordionLink.addClass('active');

        allLinks.removeClass('active');
        newLink.addClass('active');


        tabContainer.css('height',tabContainer.height());
        newTab.css('opacity',0);
        newTab.css('height','');
        TweenLite.to(oldTab,ltr6_module_tabs.fadeSpeed,{opacity:0,onComplete:function(){
          allTabs.removeClass('active');
          newTab.addClass('active');
          var newTabHeight = newTab.prop('scrollHeight');
          TweenLite.to(newTab,ltr6_module_tabs.fadeSpeed,{opacity:1});
          TweenLite.to(tabContainer,ltr6_module_tabs.fadeSpeed,{height:newTabHeight,onComplete:function(){
            tabContainer.css('height','auto');
          }});
        }});

        // scroll to top of tab content if off top of screen
        // var tabTop = $('#ltr6-wrapper .ltr6-tabs')[0].offsetTop;
        var tabTop = tabGroup[0].offsetTop;

        // var headerHeight = $('header')[0].offsetTop;
        var headerHeight = $('nav.c-nav').height();
        var secondaryNavHeight = $('nav.c-nav-secondary').height();
        var currentScrollPos = document.documentElement.scrollTop || document.body.scrollTop;
        var scrollToPos = tabTop - headerHeight - secondaryNavHeight;
        if(currentScrollPos > scrollToPos){
          TweenLite.to(window, 0.5, {scrollTo:{y:scrollToPos},ease:Power1.easeInOut});
        }

        
        var title = newLink.text();


        ltr6_module_analytics.tracking_adobe(title,'Button','Click','Tabs - ' + trackingName);
        ltr6_module_analytics.tracking_decibel(title,'Button','Click','Tabs - ' + trackingName);

      }

    };

    return ltr6_module_tabs;
}(ltr6_module_tabs || {}));
